module.exports = __webpack_public_path__ + "static/media/pdfPreview--placeholder.3debd069.jpg";